"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICloseType = void 0;
var ICloseType;
(function (ICloseType) {
    ICloseType[ICloseType["Visible"] = 1] = "Visible";
    ICloseType[ICloseType["Always"] = 2] = "Always";
    ICloseType[ICloseType["Selected"] = 3] = "Selected";
})(ICloseType = exports.ICloseType || (exports.ICloseType = {}));
//# sourceMappingURL=ICloseType.js.map